export class Logger {
    debug(...args) {
        // Do nothing
    }
    log(...args) {
        // Do nothing
    }
    warn(...args) {
        // Do nothing
    }
    error(...args) {
        // Do nothing
    }
}
export class NullLogger extends Logger {
}
export class ErrorLogger extends Logger {
    error(...args) {
        console.error("[Jolt] ", ...args);
    }
}
export class WarnLogger extends ErrorLogger {
    warn(...args) {
        console.warn("[Jolt] ", ...args);
    }
}
export class InfoLogger extends WarnLogger {
    log(...args) {
        console.log("[Jolt] ", ...args);
    }
}
export class DebugLogger extends InfoLogger {
    debug(...args) {
        console.debug("[Jolt] ", ...args);
    }
}
export const loggers = {
    none: NullLogger,
    debug: DebugLogger,
    info: InfoLogger,
    warn: WarnLogger,
    error: ErrorLogger,
};
//# sourceMappingURL=Logger.js.map